@use "../../styling/colors.scss" as *;
@use "../../styling/form-controls.scss" as *;
@use "../../styling/typography.scss" as *;

.ChooseDate {
  @extend %font-family-primary;

  font-size: 10px;
  text-align: center;
  position: relative;

  button {
    @extend %font-family-primary;
    font-size: 10px;
    border: none;
    background: none;
    padding-inline: 0px;
    padding-block: 0px;
  }

  .MonthGridWrapper {
    display: inline-table;
    border-spacing: 0.5em;
    user-select: none;
  }

  .Header {
    // The month and year
    font-size: $font-size-normal;
    color: $theme-color-text;
  }

  .Weeks {
    display: table-header-group;
  }

  .Weekdays, .Week {
    display: table-row;
    margin: 1em 0;
    border-bottom: 30px solid transparent;

    > th, > td {
      // includes empty cells
      display: table-cell;
      width: 15px;
      height: 15px;
      // To prevent bumping on day hover
      border: 1px solid transparent;
    }
  }

  .Weekday {
    display: table-cell;
    padding: 0.75em;
    color: $form-control-color;
    text-align: center;
    font-weight: $font-weight-normal;
  }

  .Day {
    button {
      width: stretch;
      text-decoration: none;
      border: 1px solid transparent;
      padding: 0.75em;
      border-radius: 50%;
      vertical-align: middle;
      text-align: center;
      cursor: pointer;
      color: $theme-color-text;
      outline: none;
    }

    &:not([aria-selected="true"]) > button:focus {
      border: 1px solid $color-primary-black;
      outline: none;
    }
  }

  button:disabled, [data-outside="true"] > button {
    opacity: 0.5;
  }

  [aria-selected="true"] > button {
    background: $form-control-color;
    border-radius: 50%;
    color: $color-white;
  }

  .PreviousButton, .NextButton {
    position: absolute;
    margin-top: 2px;
    width: 1.25em;
    height: 1.25em;
    cursor: pointer;
    color: $theme-color-text;
  }

  .PreviousButton {
    svg {
      display: none;
    }

    &::before {
      // Left caret
      content: "\003c";
    }

    left: 15px;
  }

  .NextButton {
    svg {
      display: none;
    }

    &::before {
      // Right Caret
      content: "\003e";
    }

    text-align: right;
    right: 15px;
  }
}
